<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'TABLE.INSURANCE_LIST' | translate"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource?.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <ng-template ngxPermissionsOnly="canAddInsurance">
          <button
            (click)="createInsurance()"
            mat-raised-button
            matTooltip="Create new insurance"
            color="primary"
            type="button"
          >
            <span class="svg-icon-md" translate="TABLE.ADD_INSURANCE">
              <span inlineSVG="./assets/media/svg/icons/General/add_circle_icon.svg"></span>
              New Insurance
            </span>
          </button>
        </ng-template>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'INSURANCE.INPUT.ID' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let insurance"> {{ insurance.id }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchID">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'INSURANCE.INPUT.ID' | translate }}</mat-label>
              <input
                matInput
                [placeholder]="'INSURANCE.INPUT.ID' | translate"
                [(ngModel)]="searchIDInput"
              />
              <button
                *ngIf="searchIDInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchIDInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'INSURANCE.INPUT.NAME' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let insurance"> {{ insurance.name }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'INSURANCE.INPUT.NAME' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchNameInput"
                [placeholder]="'INSURANCE.INPUT.NAME' | translate"
              />
              <button
                *ngIf="searchNameInput"
                matSuffix
                mat-icon-button
                (click)="searchNameInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="bin">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'INSURANCE.INPUT.BIN' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let insurance"> {{ insurance.bin }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchBin">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'INSURANCE.INPUT.BIN' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchBinInput"
                [placeholder]="'INSURANCE.INPUT.BIN' | translate"
              />
              <button
                *ngIf="searchBinInput"
                matSuffix
                mat-icon-button
                (click)="searchBinInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="pcn">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'INSURANCE.INPUT.PCN' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let insurance"> {{ insurance.pcn }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchPcn">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'INSURANCE.INPUT.PCN' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchPcnInput"
                [placeholder]="'INSURANCE.INPUT.PCN' | translate"
              />
              <button
                *ngIf="searchPcnInput"
                matSuffix
                mat-icon-button
                (click)="searchPcnInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="submissionType">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'INSURANCE.INPUT.SUBMISSION_TYPE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let insurance"> {{ insurance.submission_type }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchSubmissionType">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'INSURANCE.INPUT.SUBMISSION_TYPE' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchSubmissionTypeInput"
                [placeholder]="'INSURANCE.INPUT.SUBMISSION_TYPE' | translate"
              />
              <button
                *ngIf="searchSubmissionTypeInput"
                matSuffix
                mat-icon-button
                (click)="searchSubmissionTypeInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="insuranceType">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'INSURANCE.INPUT.INSURANCE_TYPE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let insurance"> {{ insurance.insurance_type }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchInsuranceType">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'INSURANCE.INPUT.INSURANCE_TYPE' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchInsuranceTypeInput"
                [placeholder]="'INSURANCE.INPUT.INSURANCE_TYPE' | translate"
              />
              <button
                *ngIf="searchInsuranceTypeInput"
                matSuffix
                mat-icon-button
                (click)="searchInsuranceTypeInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="phone">
          <mat-header-cell *matHeaderCellDef mat-sort-header
            >{{ 'INSURANCE.INPUT.PHONE' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let insurance" class="phone-hyper-style"
            >{{ insurance.phone | phoneFormat }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchPhone">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'INSURANCE.INPUT.PHONE' | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="searchPhoneInput"
                [mask]="'(000) 000-0000'"
                [placeholder]="'INSURANCE.INPUT.PHONE' | translate"
              />
              <button
                *ngIf="searchPhoneInput"
                matSuffix
                mat-icon-button
                (click)="searchPhoneInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let insurance">
            <ng-template ngxPermissionsOnly="canEditInsurance">
              <button
                matTooltip="{{ 'TABLE.UPDATE' | translate }} Insurance"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="editInsurance(insurance.id)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canSoftDeleteInsurance">
              <button
                matTooltip="{{ 'TABLE.DELETE' | translate }} Insurance"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="deleteInsurance(insurance)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>

